import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SelectNetwork } from '../../../components';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import {
  SendingTokenType,
  dateDifferenceInDaysFromToday,
  formatUSD
} from '../../../helpers/helperFunctions';
import { CaptionText, H2, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed, SelectedUSDT } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { WalletsType } from '../../../types/types';
import { PurchaseSteps, Tokens } from '../Maeketplace.types';
import { SelectToken } from '../../../components/common/SelectNetwork/SelectToken';
import { Node } from '../../../components/common/Node/Node';

interface PayTetherProps {
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedPackage: any;
  selectedLicence: any;
  selectedNetwork: WalletsType;
  setSelectedNetwork: Dispatch<SetStateAction<WalletsType>>;
  selectedToken: any;
  setSelectedToken: Dispatch<SetStateAction<any>>;
  setUsdt: Dispatch<SetStateAction<string>>;
  setUsdc: Dispatch<SetStateAction<string>>;
  lp: string;
  club: string;
  cash: string;
  calculatedPrice: string;
  handlePay: (step: PurchaseSteps) => void;
}

export const PayTether = ({
  selectedPackage,
  selectedLicence,
  selectedNetwork,
  setSelectedNetwork,
  selectedToken,
  setSelectedToken,
  calculatedPrice,
  handlePay
}: PayTetherProps) => {
  const { userInfo } = useAppSelector((state) => state.auth);

  const { t } = useTranslation('marketplace');

  const handlePayTether = (event: any) => {
    event.currentTarget.disabled = true;
    handlePay(PurchaseSteps.SUCCESS);
  };

  const amountToPay = selectedLicence
    ? selectedPackage?.subscriptionPrice
      ? selectedLicence.price +
        selectedPackage?.price +
        selectedPackage?.subscriptionPrice
      : selectedLicence.price + selectedPackage?.price
    : selectedPackage?.subscriptionPrice
    ? selectedPackage?.subscriptionPrice + selectedPackage?.price
    : selectedPackage?.price;

  const licenceDate = dateDifferenceInDaysFromToday(
    userInfo.user.currentVirtualOfficeLicence?.dateEnd
  );

  return (
    <div>
      <P1 bold mb='20' center style={{ fontFamily: 'Nulshock' }}>
        YOUR ORDER:
      </P1>
      <P2 center>
        To complete the order please send the funds to the dedicated wallet
        address below.
      </P2>
      <P2 center bold mb='20'>
        Payment instructions were also sent on your email.
      </P2>
      <Node
        key={selectedPackage?.id}
        condensed
        showTickets={false}
        image={selectedPackage?.imageUrl}
        title={selectedPackage?.name}
        price={selectedPackage?.price}
        packagePrice={selectedPackage?.price}
        info={<></>}
      />
      {licenceDate <= 30 && licenceDate > 0 && (
        <Flexed between center mb='40' ml='90' mr='90'>
          <div>
            <H4 bold center>
              Backoffice licence{' '}
            </H4>

            <P3>
              {selectedLicence?.title} {selectedLicence?.title2}
            </P3>
          </div>
          <H4 bold center>
            {selectedLicence?.price} USDT
          </H4>
        </Flexed>
      )}

      <P2 center>Make sure that you are sending</P2>
      <P2 center bold mb='20'>
        total amount in USDT or USDC on <br />
        Binance Smart Chain
      </P2>
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        Total Amount
      </P3>
      <SelectedUSDT>
        {formatUSD(amountToPay)}
        <div>USDT/USDC</div>
      </SelectedUSDT>
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        Blockchain Network
      </P3>
      <SelectNetwork
        disabled
        onChange={(n) => setSelectedNetwork(n)}
        value={selectedNetwork}
      />

      <Button mt={20} onClick={handlePayTether}>
        Continue
      </Button>
    </div>
  );
};
